import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type TemplateNotFoundErrorOptions = {
  template: ObjectId;
};

export class TemplateDeploymentNotFoundError extends FleekError<TemplateNotFoundErrorOptions> {
  public name = 'TemplateDeploymentNotFoundError';

  toString = () => `Template deployment not found.`;
}
